import apiClient from './client'

/**
 * 教材编写相关API
 */

export interface ProfileStatistics {
  totalTextbooks: number
  totalChapters: number
  totalWords: number
  approvedRate: number
  completedTasks: number
  pendingReview: number
  inProgressTasks: number
  pendingTasks: number
  overdueTasks: number
  approvedChapters: number
  rejectedChapters: number
}

export interface WritingTask {
  taskId: number
  textbookId: number
  chapterId?: number
  assignerId: number
  assignerName: string
  assigneeId: number
  assigneeName: string
  taskType: 'writing' | 'review' | 'revise'
  taskTitle: string
  taskDescription?: string
  priority: 'low' | 'normal' | 'high' | 'urgent'
  deadline: string
  status: 'pending' | 'in_progress' | 'completed' | 'cancelled'
  progress: number
  startTime?: string
  completeTime?: string
  createTime: string
  updateTime?: string
  remark?: string
  // 关联数据
  textbookTitle?: string
  chapterTitle?: string
  chapterNumber?: number
}

/**
 * 获取个人中心统计数据
 */
export const getProfileStatistics = async (userId?: number): Promise<ProfileStatistics> => {
  const params = userId ? { userId } : {}
  const response = await apiClient.get('/v1/textbook/profile/statistics', { params })
  
  // 处理不同的响应格式
  if (response.code === 200) {
    return response.data
  } else if (response.data) {
    return response.data
  } else {
    return response
  }
}

/**
 * 获取任务列表
 */
export const getTaskList = async (params?: {
  status?: string
  taskType?: string
  priority?: string
  pageNum?: number
  pageSize?: number
}): Promise<{ rows: WritingTask[]; total: number }> => {
  const response = await apiClient.get('/v1/textbook/tasks/list', { params })
  
  if (response.code === 200) {
    return {
      rows: response.rows || [],
      total: response.total || 0
    }
  } else if (response.data) {
    return {
      rows: Array.isArray(response.data) ? response.data : response.data.rows || [],
      total: response.data.total || 0
    }
  } else {
    return { rows: [], total: 0 }
  }
}

/**
 * 获取任务详情
 */
export const getTaskDetail = async (taskId: number): Promise<WritingTask> => {
  const response = await apiClient.get(`/v1/textbook/tasks/${taskId}`)
  
  if (response.code === 200) {
    return response.data
  } else if (response.data) {
    return response.data
  } else {
    return response
  }
}

/**
 * 开始任务
 */
export const startTask = async (taskId: number): Promise<void> => {
  await apiClient.post(`/v1/textbook/tasks/${taskId}/start`)
}

/**
 * 提交任务
 */
export const submitTask = async (taskId: number): Promise<void> => {
  await apiClient.post(`/v1/textbook/tasks/${taskId}/submit`)
}

/**
 * 申请延期
 */
export const requestExtension = async (taskId: number, reason: string): Promise<void> => {
  await apiClient.post(`/v1/textbook/tasks/${taskId}/extension`, { reason })
}
